// @flow
import { LARGE_VIEWPORT, MEDIUM_VIEWPORT, SMALL_VIEWPORT } from '@alphaott/app-config'
import { rgba } from 'polished'

import { colorPalette } from '../colorPalettes'
import type { ColorType } from '../colorPalettes'

export const miplayColors: ColorType = {
  ...colorPalette,
  primary: '#28ABE2',
  secondary: '#28ABE2',
  signColor: 'linear-gradient(132.34deg, #EEEEEE 0%, #D8D8D8 100%)',
}

export const lightTheme = {
  colors: miplayColors,
  background: {
    primary: '#fafafa',
    secondary: '#fafafa',
    highlight: miplayColors.light,
    select: '#fafafa',
    footerTop: '#eee',
  },
  text: {
    primary: miplayColors.dark,
    secondary: miplayColors.grayText,
    disabled: miplayColors.dark,
    link: miplayColors.dark,
    hint: miplayColors.dark,
    highlight: miplayColors.primary,
    gray: miplayColors.grayText,
    seeAll: 'rgba(52, 73, 94, 0.8)',
    primaryContrast: '#ffffff',
  },
  border: {
    primary: '#dddddd',
    gray: '#ddd',
  },
  filter: {
    primary: '#43484d',
    secondary: '#43484d',
    disabled: miplayColors.grayLabel,
    highlight: '#fff',
  },
  tabs: {
    bg: '#fafafa',
    containerBg: miplayColors.dark,
    color: miplayColors.dark,
    border: miplayColors.primary,
    scrollbarThumb: miplayColors.primary,
    programTitle: miplayColors.white,
  },
  programGuide: {
    programBox: {
      background: {
        main: 'rgba(221, 221, 221, 0.8)',
        hover: miplayColors.dark,
        selected: miplayColors.dark,
        progress: rgba(miplayColors.primary, 0.3),
        past: rgba(miplayColors.primary, 0.3),
        pastSelected: miplayColors.dark,
        pastHover: miplayColors.dark,
        empty: 'rgba(221, 221, 221, 0.3)',
        emptyProgress: rgba(miplayColors.primary, 0.1),
      },
      text: {
        empty: miplayColors.grayLabel,
      },
    },
    programGuidePictureOverlay: {
      horizontal:
        // eslint-disable-next-line max-len
        `linear-gradient(90deg, #fafafa 0%,${rgba('#fafafa', 0.97)} 13.03%,${rgba('#fafafa', 0.69)} 43.24%,${rgba(
          '#fafafa',
          0,
        )} 100%);`,
      vertical: `linear-gradient(0,#fafafa 0%,${rgba('#fafafa', 0.73)} 34.97%,${rgba('#fafafa', 0)} 100%);`,
    },
  },
  card: {
    title: miplayColors.dark,
    subTitle: miplayColors.grayText,
    bg: miplayColors.dark,
    number: miplayColors.grayBorder,
    boxShadow: 'rgba(221, 221, 221, 0.8)',
    loaderBackgroundImage: 'linear-gradient(to right, #f6f7f8 0%, #edeef1 20%, #f6f7f8 40%, #f6f7f8 100%)',
  },
  dimension: {},
  size: 'default',
  breakpoints: [`${SMALL_VIEWPORT}px`, `${MEDIUM_VIEWPORT}px`, `${LARGE_VIEWPORT}px`],
  signIn: {
    clipPath: false,
    hideBgImage: true,
  },
}
